import { AbsencePlannerEventsContainerDirective } from '../../../features/absence-planner/directives/absence-planner-events-container.directive';
import { UserModel } from '../user/user.model';
import { EventSlotDirective } from '../../../features/absence-planner/directives/event-slot.directive';
import { WeekdayOrdinal } from '../../../features/calendar/calendar-types';
import { PlanerWeek } from '../../../features/absence-planner/utils/absence-planner-types';
import { AbsencePlannerEventModel } from './absence-planner-event.model';
import { AbsencePlannerComponent } from '../../../features/absence-planner/absence-planner.component';
import { signal } from '@angular/core';

export class AbsencePlannerModel {
  public plannerEventsContainer: Map<number, AbsencePlannerEventsContainerDirective[]> = new Map(); // All container of the planner.
  public eventSlots: Map<number, EventSlotDirective[]> = new Map(); // All slots of the planner per member.
  public plannerEventModels = signal<AbsencePlannerEventModel[]>(null);
  public members: UserModel[] = null;
  public plannerStartOfMonth: Date = null; // The first date of the selected month.
  public plannerEndOfMonth: Date = null; // The last date of the selected month.
  public plannerWeeks: PlanerWeek[] = []; // All visible weeks of the planner.
  public weekStartsOn: WeekdayOrdinal = null;
  public slotWidth: number = null;
  public plannerComponentInstance: AbsencePlannerComponent;
  public htmlGrid: HTMLTableElement = null;
  public workTimeStart: Date = null;
  public workTimeEnd: Date = null;
}
